import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

export const FeesSidebarWrapper = styled('div', {
  base: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgb(209, 209, 213)',
    borderRadius: '4px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.3)',
    display: 'flex',
    flexDirection: 'column',
    gap: '2x',
    height: 'fit-content',
    padding: '2x',
    flexShrink: 0,
    width: '300px',
    '@media (max-width: 1023px)': {
      width: '100%',
    },
  },
});

export const Text = styled('div', {
  base: {
    fontSize: 'sm',
  },
});

export const EstimateTitle = styled('div', {
  base: {
    fontSize: 'md',
    fontWeight: 700,
  },
});

export const Price = styled('div', {
  base: {
    fontSize: 'xl',
    fontWeight: 700,
    paddingBottom: '1x',
  },
});

export const FeeType = styled('div', {
  base: {
    fontSize: 'md',
  },
});

export const RoomsRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1x',
    flexWrap: 'wrap',
  },
});

export interface RoomButtonProps {
  active: boolean;
}

// Helper function to create dynamic CSS for the RoomButton based on active state
export const getRoomButtonStyles = (active: boolean) =>
  css({
    backgroundColor: active ? 'hpxTeal500' : 'hpxWhite',
    borderRadius: '14px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxTeal500',
    cursor: 'pointer',
    paddingTop: '4px',
    paddingRight: '12px',
    paddingBottom: '4px',
    paddingLeft: '12px',
    minWidth: '0px',
    color: active ? 'hpxWhite' : 'hpxTeal500',
    textTransform: 'none',
    fontWeight: 700,
    fontSize: 'sm',
    height: '28px',
  });

// We don't export RoomButton as a styled component anymore since it needs the dynamic props
// Instead, in the component, we'll use:
// <button className={getRoomButtonStyles(props.active)}>...</button>
